module.exports = __webpack_public_path__ + "static/media/Acharya_Pavitra_Pratica_Vivek.09795c85.jpg";